import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Card,
  CardContent,
  Typography,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import PersonIcon from "@mui/icons-material/Person";

const PowerRegularizationPopup = ({ open, onClose }) => {
  return (
    <div className="fixed top-4 right-4 z-50 w-80 bg-white rounded-lg shadow-lg">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <h2 className="text-lg font-semibold flex items-center gap-2">
          🔄 New Power Regularization Request
        </h2>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
          &times;
        </button>
      </div>

      {/* Content */}
      <div className="p-4">
        <div className="flex items-center bg-gray-100 rounded-lg p-3 shadow">
          <span className="text-blue-500 text-2xl">👤</span>
          <div className="ml-3 flex-1">
            <p className="font-semibold">
              Rahul Rawat,{" "}
              <span className="text-gray-500">Udham Singh Nagar</span>
            </p>
            <p className="text-sm">
              <strong>SRO:</strong> Kashipur
            </p>
            <p className="text-xs text-gray-500">4 hours ago</p>
          </div>
          <a href="#" className="text-blue-500 text-sm font-semibold">
            view all
          </a>
        </div>
      </div>
    </div>
  );
};

export default PowerRegularizationPopup;
